import { v4 } from "uuid";

export const dataImage = [
	{
		idImg: v4(),
		src: "img/GridMenuImage/LogoKokaBulat.png",
		alt: "Koka",
		linkTo: "/kokamenu",
	},
	{
		idImg: v4(),
		src: "img/GridMenuImage/LogoCocaBulat.png",
		alt: "Coca",
		linkTo: "/kokamenu#cocamenu",
	},
	{
		idImg: v4(),
		src: "img/GridMenuImage/LogoLowcostBulat.png",
		alt: "Lowcost",
		linkTo: "/kokamenu#lowcost",
	},
];
